<template>
<video
	v-if="animate && videoUrl"
	ref="video"
	style="width:100%" loop autoplay
>
	<source :src="videoUrl">
</video>
<picture
	v-else-if="!isOwnUser(account, user)"
>
	<img :src="imgUrl + updateQuerystring" @dragover.prevent @drop.prevent>
</picture>
<picture
	v-else
	ref="uploaderTarget"
	@click="openUploader"
	@dragover.prevent
	@drop="onOuterDrop"
>
	<a>Upload New</a>
	<img :src="imgUrl + updateQuerystring">
	<user-image-upload v-show="uploadActive" ref="uploader" :user="user" />
</picture>
</template>

<script>
import accountFns from '../js/account-functions.js'
import account from '../js/account.js'
import { imgUrl, videoUrl } from '../js/user-functions.js'
import { createPopper } from '@popperjs/core'
import UserImageUpload from './user-image-upload.vue'
import socket from '../js/socket.js'

export default {
	components: {
		'user-image-upload': UserImageUpload
	},
	props: {
		user: {
			type: [Number, Object],
			required: true
		},
		animate: {
			type: [Boolean],
			default: false
		},
		editanddel: {
			type: Boolean
		}
	},
	data(){
		return {
			uploadActive: false,
			account
		}
	},
	computed: {
		imgUrl: function(){
			return imgUrl( this.user, this.account )
		},
		videoUrl: function(){
			return videoUrl( this.user )
		},
		updateQuerystring: function(){
			return this.user.lastUploadEpoch ? '?' + this.user.lastUploadEpoch : ''
		}
	},
	watch: {
		videoUrl(){
			this.$nextTick( () => {
				this.$refs.video && this.$refs.video.load()
				// this.$refs.video && this.$refs.video.play()
			})
		}
	},
	methods: {
		isOwnUser: accountFns.isOwnUser,
		onOuterDrop: function( ev ){
			this.$refs.uploader.onDrop( ev )
			this.openUploader( ev )
		},
		openUploader: function( ev ){
			if( this.uploadActive === true ){
				return false
			}
			this.uploadActive = true

			document.body.appendChild( this.$refs.uploader.$el )

			this.$refs.uploader.popper = createPopper( this.$refs.uploaderTarget, this.$refs.uploader.$el, {
				placement: 'right',
				modifiers: [
					{
						name: 'preventOverflow',
						options: {
							boundary: window
						}
					},
					{
						name: 'arrow',
						enabled: false
					},
					{
						name: 'flip',
						options: {
							fallbackPlacements: ['left', 'right'],
							boundary: document.body
						}
					}
				]
			})

			const removeUploader = () => {
					this.uploadActive = false
					if( this.$refs.uploader.$el && document.contains( this.$refs.uploader.$el ) ){
						document.body.removeChild( this.$refs.uploader.$el )
						document.body.removeEventListener( 'click', clickOutsideHider )
					}
				},

				clickOutsideHider = ( ev ) => {
					if( ev.target && ev.target !== this.$refs.uploader.$el && !this.$refs.uploader.$el.contains( ev.target ) && ev.target !== this.$el && !this.$el.contains( ev.target ) ){
						removeUploader()
					}
				}

			document.body.addEventListener( 'click', clickOutsideHider )

			socket.once( 'upload-complete', () => {
				removeUploader()
			})
		}
	}
}
</script>